module.exports = __webpack_public_path__ + "static/media/HomeParking.393eeb3f.jpg";